module.exports = __webpack_public_path__ + "img/2014-03_bloomberg.cf8871dc.png";